/*
* Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
* This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
* The receipt or possession of this program does not convey any rights to use, reproduce or disclose
* its contents in whole or in part, without the specific written consent of Inovalon, Inc.
* Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
* is a violation of the copyright laws and may subject you to criminal prosecution.
*/
import React from 'react'
import './Copays.scss'
import { CommonUtils } from '../../../../utils/CommonUtils'
import NumberFormat from 'react-number-format'
import { IInpatientTypeInsurance } from '../../../../services/CoverageDiscoveryResponseStateManager/contracts'

export interface ICopaysProps {
	data: IInpatientTypeInsurance
}
export class Copays extends React.Component<ICopaysProps> {
	index = 0
	render(): React.ReactNode {
		const copaysModel = this.props.data

		if (!copaysModel.coPayments) {
			return <></>
		}

		const rowsEpisode: JSX.Element[] = []
		if (copaysModel.coPayments.episodes && copaysModel.coPayments.episodes.length) {
			const episodes = copaysModel.coPayments.episodes.sort(a => (a.startDate ? 1 : -1))
			const groupedEpisodes = CommonUtils.groupBy(episodes, sechedule => sechedule.startDate + sechedule.endDate)
			groupedEpisodes.forEach(episode => {
				rowsEpisode.push(this.getEpisodesContent(episode[0], episode[1], copaysModel.coPayments && copaysModel.coPayments.periodDefinition, episode.isDolbaDoebaPresent))
			})
		}

		const rowsSchedule: JSX.Element[] = []
		if (copaysModel.coPayments.schedules && copaysModel.coPayments.schedules.length > 0) {
			const sechedules = copaysModel.coPayments.schedules.sort(a => (a.startDate ? 1 : -1)).sort(a => (a.fromPeriod ? 1 : -1))
			const groupedSchedules = CommonUtils.groupBy(sechedules, sechedule => sechedule.startDate + sechedule.endDate)
			let first = true
			groupedSchedules.forEach(schedule => {
				rowsSchedule.push(this.getSchedulesContent(first, schedule[0], schedule[1], copaysModel.coPayments && copaysModel.coPayments.periodDefinition))
				first = false
			})
		}

		return (
			<>
				{rowsEpisode.length > 0 && rowsEpisode.map(item => item)}
				{rowsSchedule.length > 0 && rowsSchedule.map(item => item)}
			</>
		)
	}

	private getEpisodesContent(periodOne: any, periodTwo: any, periodDefinition: any, isDolbaDoebaPresent: boolean): JSX.Element {
		const curRange = CommonUtils.DateRange(periodOne.startDate, periodOne.endDate, true)
		return (
			<>
				<tr className="quartered">
					<td>{periodDefinition}:</td>
					<td className="bottom-border-td">{curRange}</td>
					<td className="bottom-border-td">
						<strong>{periodOne.remaining}</strong>
						{periodDefinition}s Remaining @{' '}
						<strong>
							<NumberFormat value={periodOne.amount} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
						</strong>
						/{periodDefinition}
					</td>
					<td className="bottom-border-td">
						<strong>{periodTwo.remaining}</strong> Co-Pay {periodDefinition}s Remaining @{' '}
						<strong>
							<NumberFormat value={periodTwo.amount} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
						</strong>
						/{periodDefinition}
					</td>
				</tr>
				{isDolbaDoebaPresent && (
					<tr>
						<td className="bottom-border-td"></td>
						<td className="bottom-border-td"></td>
						<td className="bottom-border-td">DOEBA: {CommonUtils.toDisplayDate(periodTwo.doeba)}</td>
						<td className="bottom-border-td">DOLBA: {CommonUtils.toDisplayDate(periodTwo.dolba)}</td>
					</tr>
				)}
			</>
		)
	}

	private getSchedulesContent(titleRequired: boolean, periodOne: any, periodTwo: any, periodDefinition: any): JSX.Element {
		const curRange = CommonUtils.DateRange(periodOne.startDate, periodOne.endDate, true)
		this.index++
		return (
			<tr key={this.index} className="quartered">
				<td>{titleRequired && 'Co-Payments:'}</td>
				<td className="bottom-border-td">{curRange}</td>
				{periodOne && (
					<td className="bottom-border-td">
						{periodDefinition}s:{' '}
						<strong>
							{periodOne.fromPeriod} - {periodOne.toPeriod} @ <NumberFormat value={periodOne.amount} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
						</strong>
						/{periodDefinition}
					</td>
				)}
				{periodTwo && (
					<td className="bottom-border-td">
						{periodDefinition}s:{' '}
						<strong>
							{periodTwo.fromPeriod} - {periodTwo.toPeriod} @ <NumberFormat value={periodTwo.amount} displayType={'text'} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={'$'} renderText={(value: string): JSX.Element => <span>{value}</span>} />
						</strong>
						/{periodDefinition}
					</td>
				)}
			</tr>
		)
	}
}
